<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Forgot Password v1 -->
      <b-overlay :show="show" rounded="sm" no-fade>
        <b-card class="mb-0">
          <b-link class="brand-logo">
            <!-- logo -->
            <img src="_logo.png" alt="Logo" />

            <h2 class="brand-text text-primary ml-1">{{ title }}</h2>
          </b-link>

          <b-card-title class="mb-1">
            {{ $t("site.Forgot_Password") }} 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t("site.Enter_your_email") }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <!-- email -->
              <b-form-group
                :label="$t('users.email')"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    :placeholder="$t('users.email')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button variant="primary" block type="submit">
                {{ $t("site.Send_reset_link") }}
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link :to="{ name: 'login' }">
              <feather-icon icon="ChevronLeftIcon" />
              {{ $t("site.back_to_login") }}
            </b-link>
          </b-card-text>
        </b-card>
      </b-overlay>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BCard,
  BLink,
  BCardText,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import UsersController from "@/Controllers/UsersController";

export default {
  components: {
    VuexyLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: "",
      // validation
      required,
      email,
      title: Title,
      show:false
    };
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
         this.show=true;
          let res = await new UsersController().forgot({
            email: this.userEmail,
            url:
              "https://" +
              window.location.hostname +
              "/dashboard/#/reset-password",
          });
            this.show=false;
          // if (res) {
          //   this.$router.push({ name: "login" });
          // }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
